<template>
	<insurance-list scene="approve"></insurance-list>
</template>

<script>
	import insuranceList from '../insurance/insurance_list'
	
	export default {
		components: {
			insuranceList
		}
	}
</script>
